

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { FormBlockDto, FormChoiceDto, FormSubmissionFieldDto, FormTextDto } from '@/api';
import FormTextField from '@/views/cms/snippet/FormTextField.vue';
import FormChoiceField from '@/views/cms/snippet/FormChoiceField.vue';
import VueRecaptcha from 'vue-recaptcha';
import { getModule } from 'vuex-module-decorators';
import { CmsStore } from '@/stores/cms.store';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import { Config } from '@/util/Config';

interface FormFieldWrapper {
  formField: FormTextDto | FormChoiceDto;
  value?: string;
}

@Component({
  components: {LoadingIndicator, FormChoiceField, FormTextField, VueRecaptcha},
})
export default class FormBlock extends Vue {
  @Prop({required: true})
  public readonly model!: FormBlockDto;

  public formFields: FormFieldWrapper[] = [];
  private cmsStore = getModule(CmsStore, this.$store);
  private captchaToken: string = '';
  private recaptchaSiteKey = Config.RECAPTCHA_SITE_KEY;
  private sendingForm: boolean = false;
  private hasSentForm: boolean = false;
  private recaptchaError: boolean = false;

  public async mounted() {
    this.formFields = this.fields.map(
      (field) => {
        return {
          formField: this.convertFormField(field),
        };
      },
    );
  }

  public get fields(): object[] {
    return this.model.fields;
  }

  private convertFormField(field: object): FormChoiceDto | FormTextDto {
    if ('type' in field) {
      const choiceField = field as FormChoiceDto;

      if (this.isChoiceType(choiceField.type)) {
        return choiceField;
      }
    }
    return field as FormTextDto;
  }

  public isChoice(field: FormFieldWrapper) {
    return 'type' in field.formField && this.isChoiceType(field.formField.type);
  }

  public async submitCms() {
    this.sendingForm = true;

    if (!this.captchaToken) {
      this.recaptchaError = true;
      this.sendingForm = false;
      return;
    }

    try {
      const formSubmissionData: FormSubmissionFieldDto[] = this.formFields.map((formField) => {
          return {
            fieldLabel: formField.formField.label,
            value: formField.value,
          };
        },
      );

      await this.cmsStore.submitCmsForm({
        webrootPath: this.model.path,
        language: this.model.language,
        formFields: formSubmissionData,
        captchaToken: this.captchaToken,
      });
    } finally {
      this.sendingForm = false;
      this.hasSentForm = true;
    }
  }

  public onVerify(token: string) {
    if (token) {
      this.captchaToken = token;
      this.recaptchaError = false;
    }
  }

  private isChoiceType(type: string): boolean {
    return type === 'select' || type === 'radio' || type === 'check';
  }
}
